import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 15.75V19.5H3V15.75H1.5V19.5C1.5 20.325 2.175 21 3 21H21C21.825 21 22.5 20.325 22.5 19.5V15.75H21Z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5446 17.0076L18.0001 11.2498H15.0001V5.24982H9.00006V11.2498H6.00006L11.4391 17.0061C11.7353 17.3308 12.2468 17.3316 12.5446 17.0076Z" // eslint-disable-line
     }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 3.75H15V2.25H9V3.75Z" })), 'DownloadFilled');
